import { render, staticRenderFns } from "./PrintStudio.vue?vue&type=template&id=12c1fc84&scoped=true&"
import script from "./PrintStudio.vue?vue&type=script&lang=js&"
export * from "./PrintStudio.vue?vue&type=script&lang=js&"
import style0 from "./PrintStudio.vue?vue&type=style&index=0&id=12c1fc84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c1fc84",
  null
  
)

export default component.exports